import React, { useMemo } from 'react';

/*
 * Decorative drifting particles (a subtle "physics field"). Pure CSS motion,
 * pointer-events none, disabled under prefers-reduced-motion (see global anim CSS).
 */
export default function ParticleField({ count = 14, className = '' }) {
  const dots = useMemo(
    () =>
      Array.from({ length: count }, () => ({
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: (Math.random() * 2 + 2).toFixed(1),
        dur: (Math.random() * 6 + 7).toFixed(1),
        delay: (-Math.random() * 9).toFixed(1),
      })),
    [count]
  );
  return (
    <div className={`pfield${className ? ` ${className}` : ''}`} aria-hidden="true">
      {dots.map((p, i) => (
        <span
          key={i}
          className="pfield__dot"
          style={{
            left: `${p.left}%`,
            top: `${p.top}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            '--dur': `${p.dur}s`,
            '--delay': `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
